import { useMemo, useEffect } from 'react';
import { batch, useDispatch } from 'react-redux';
import { EAssistantPhase } from '../../../../store/reducers/admin/assistant';
import Icon, { ICONS, COLORS } from '../../../general-ui/icon';
import WelcomeAssistant from './welcome';
import MenuAssistant from './menu';
import ProgressAssistant from './progress-checklist';
import './assistant.scss';
import HelpCenter from './help-center';
import { useTypedSelector } from '../../../../store/reducers/use-typed-selector';
import { toggleAssistant, updatePhase } from '../../../../store/actions/admin/assistant';

const Assistant: React.FC = () => {
	const {
		AuthReducer: {
			user
		},
		AssistantReducer: {
			currentPhase,
			open
		}
	} = useTypedSelector(state => state);

	const dispatch = useDispatch();

	const popoverContent = useMemo(() => {
		switch (currentPhase) {
			case EAssistantPhase.MENU: {
				return <MenuAssistant />;
			}
			case EAssistantPhase.WELCOME: {
				return <WelcomeAssistant />;
			}
			case EAssistantPhase.PROGRESS: {
				return <ProgressAssistant />;
			}
			case EAssistantPhase.HELP_CENTER: {
				return <HelpCenter />;
			}
			default: return;
		}
	}, [currentPhase]);

	function handleClick(open: boolean) {
		dispatch(toggleAssistant(!open));
	}

	// On first render, if user has not completed the welcome onboarding, open assistant to the welcome phase
	useEffect(() => {
		if (!user?.onboarded.includes("welcome")) {
			batch(() => {
				dispatch(updatePhase(EAssistantPhase.WELCOME));
				dispatch(toggleAssistant(true));
			});
		} else {
			dispatch(toggleAssistant(false));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="assistant-container">
			<button className="assistant-button round" onClick={() => handleClick(open)}>
				<Icon name={open ? ICONS.CLOSE : ICONS.QUESTION} size={20} color={COLORS.BLACK} />
			</button>
			<div className={open ? "assistant-popover-container open" : "assistant-popover-container"}>
				<div className="assistant-popover-content">
					{popoverContent}
				</div>
			</div>
		</div>
	);
};

export default Assistant;